export default __webpack_public_path__ + "static/media/benefit5.9b1d11f2.svg";